export default __webpack_public_path__ + "static/media/defaultLogo.85aa00d7.svg";